// Layers whose icon symbols should bypass Mapbox's default collision-culling.
// These are densely co-located datasets (the PG&E D2 Land Records family) where
// icons need to stack visually instead of having Mapbox hide overlapped ones;
// otherwise users can't see or click through to every feature's metadata.
// Source of truth for these IDs: packages/tile-server/src/TileServer/tileUrlMap.ts
const ALLOW_SYMBOL_OVERLAP_LAYER_IDS: ReadonlySet<string> = new Set([
  'pgeD2LandRecords',
  'pgeD2LandRecordSurveyPoint',
  'pgeD2LandRecordSurveyLine',
  'pgeD2LandRecordSurveyPoly',
  'pgeD2LandRecordCoveragePoly',
  'pgeD2LandRecordSurveyControl',
  'pgeD2LandRecordPropertyBoundary',
  'pgeD2LandRecordEasementBoundary',
  'pgeD2FeeOwnership',
  'pgeD2Easements',
  'pgeD2LeasesToPGE',
  'pgeD2LicensesToPGE',
  'pgeD2FinalOrdersOfCondemnation',
  'pgeD2Agreements',
  'pgeD2GeneralTransfers',
  'pgeD2MortgageReleasesAndIndentures',
  'pgeD2MasterAgreements',
  'pgeD2PermitsToPGE',
  'pgeD2ConveyancesOut',
  'pgeD2StreetVacationResolutions',
  'pgeD2SupportingDocuments',
  'electricDistributionStructures',
  'electricDistributionDevices',
]);

function shouldAllowSymbolOverlap(layerId: string): boolean {
  return ALLOW_SYMBOL_OVERLAP_LAYER_IDS.has(layerId);
}

// Symbol layers are always point-rendered here (`symbol-placement: 'point'`), so the flag
// applies to every symbol layer rather than matching against the allowlist above.
export function resolveAllowSymbolOverlap(layerId: string, allowOverlapForAllPointLayers: boolean): boolean {
  return allowOverlapForAllPointLayers || shouldAllowSymbolOverlap(layerId);
}
